import React, { Component } from 'react'
import SectionContentTypes from "./content/ContentTypes.jsx"
import EditButtonSectionModal from "./editbutton.component.jsx";
import { FormattedMessage } from "react-intl";
import Icon from "../../common/icon/icon.component.jsx";
import ContentTypeSelector from "./content/select.component.jsx";
import $ from "jquery"
import TemplateSelector from "../../common/template/selection.component.jsx";
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import EventBus from "../../common/EventBus.js";

class SectionWrapper extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || 'row',
            clickable: this.props.clickable === undefined ? true : this.props.clickable,
            style: this.props.style || {},
            section: this.props.section || null,
            variables: this.props.variables || null,
            isDummy: this.props.isDummy || false,
            isPdf: this.props.isPdf || false,
            included: this.props.included || false,
            noContainer: this.props.noContainer || false,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            showToolbar: false,
            id: this.props.id || '',
            snippetId: '',
        }
        this.showEdition = this.showEdition.bind(this)
        this.hideEdition = this.hideEdition.bind(this)
        this.toggleToolbar = this.toggleToolbar.bind(this)
        this.includeSnippet = this.includeSnippet.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            style: nextProps.style || {},
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isDummy: nextProps.isDummy || false,
            id: nextProps.id || '',
        })
    }

    showEdition() {
        if (this.state.editable) {
            this.setState({
                edition: true,
            })
        }
    }

    hideEdition() {
        if (this.state.editable) {
            this.setState({
                edition: false,
            })
        }
    }

    includeSnippet(e) {
        e.preventDefault()
        if (this.state.editable) {
            AppContext.getApiClient().put('/documents/' + this.state.section.attributes.documentId + '/include', {
                documentId: this.state.snippetId,
                position: this.state.section.attributes.rank,
            }).then((response) => {
                if (!response.error) {
                    EventBus.dispatch(EventBus.TopicProposalPreviewRefresh, {
                        sectionId: this.state.sectionId
                    })
                    this.setState({
                        showToolbar: false,
                        edition: false,
                    })
                }
            })

        }
    }

    toggleToolbar(event) {
        event.preventDefault()
        this.setState({
            showToolbar: !this.state.showToolbar
        }, () => {
            if (!this.state.showToolbar) {
                return
            }
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#content-type-selector-' + this.state.id).offset().top - 80
            }, 500)
        })
    }

    render() {
        let extraClass = ''
        if (this.state.edition || this.state.showToolbar) {
            extraClass = ' bg-toolbar'
        }

        if (this.state.isPdf) {
            return this.props.children
        }

        let onClick = () => { }
        if (this.state.clickable) {
            onClick = () => SectionContentTypes.openSectionEditor(this.state.section.id)
        }

        const rows = []
        if (this.state.noContainer) {
            rows.push(this.props.children)
        } else {
            rows.push(
                <div className="row" onClick={onClick} key={1}>
                    {this.props.children}
                </div>
            )
        }

        if (this.state.edition || this.state.showToolbar) {
            rows.push(
                <div className="row" key={2}>
                    <div className={'col-12 text-center mt-1 bg-white'} style={{
                        height: this.state.showToolbar ? 'auto' : '0px',
                        zIndex: 999,
                    }}>
                        {this.state.showToolbar ? <div className={'row'}>
                            <div id={'content-type-selector-' + this.state.id} className={'col-6 pt-3'}>
                                <div className={'row'}>
                                    <div className={'col-12 pb-2'}>
                                        <h4>
                                            <FormattedMessage
                                                id="proposal.section.new_content_title"
                                                defaultMessage="New content"
                                            />
                                        </h4>
                                    </div>
                                </div>
                                <ContentTypeSelector type={this.state.variables.document.type} onChange={contentType => {
                                    SectionContentTypes.addNewSection(contentType, this.state.section.attributes.rank)
                                    this.setState({
                                        showToolbar: false,
                                        edition: false,
                                    })
                                }} />
                            </div>
                            <div className={'col-6 pt-3 border-left'}>
                                <div className={'row'}>
                                    <div className={'col-12 pb-2'}>
                                        <h4>
                                            <FormattedMessage
                                                id="proposal.section.include_snippet_title"
                                                defaultMessage="Include a snippet"
                                            />
                                        </h4>
                                    </div>
                                    <div className={'col-12 text-left'}>
                                        <TemplateSelector
                                            documentType={'snippet'}
                                            value={this.state.snippetId}
                                            onChange={val => this.setState({ snippetId: val })}
                                        />
                                    </div>
                                    <div className={'col-12 pt-3'}>
                                        <button className={'btn btn-primary pr-3'} onClick={this.includeSnippet}>
                                            <Icon value={'arrow-circle-down'} className={'mr-1'} />
                                            <FormattedMessage
                                                id="proposal.section.include_button"
                                                defaultMessage="Include"
                                            />
                                        </button>
                                    </div>

                                </div>

                            </div>
                            <div className={'col-12 py-2'}>
                                <button className={'btn btn-secondary btn-md-rounded pr-3'}
                                    onClick={() => { this.setState({ edition: false, showToolbar: false }) }}>
                                    <Icon value={'times'} />
                                    <FormattedMessage
                                        id="proposal.section.cancel_button"
                                        defaultMessage="Cancel"
                                    />
                                </button>
                            </div>
                        </div> : <button className={'btn btn-primary btn-md-rounded pr-3'} style={{
                            marginTop: '-1.5rem',
                        }} onClick={this.toggleToolbar}>
                            <Icon value={'plus'} className={'mr-1'} />
                            <FormattedMessage
                                id="proposal.section.add_button"
                                defaultMessage="Add"
                            />
                        </button>}
                    </div>
                </div>
            )
        }
        const sectionClassName = !this.state.included ? 'section-size ' : ''
        return (
            <div className={sectionClassName + this.state.className + extraClass} id={this.state.id} style={this.state.style}>
                <EditButtonSectionModal
                    onMouseEnter={this.showEdition}
                    onMouseLeave={this.hideEdition}
                    sectionId={this.state.section.id}
                    documentId={this.state.section.attributes.documentId}
                    onClose={this.state.onEdit}
                    editable={this.state.editable}
                    variables={this.state.variables}
                    onAddSection={() => {
                        this.setState({
                            showToolbar: true,
                        }, () => {
                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#content-type-selector-' + this.state.id).offset().top - 80
                            }, 500)
                        })

                    }}
                />
                <div className="col-12 text-left" onMouseEnter={this.showEdition} onMouseLeave={this.hideEdition}>
                    {rows}
                </div>
            </div>
        );
    }
}

export default SectionWrapper





// WEBPACK FOOTER //
// ./src/template/sections/sectionwrapper.component.jsx